var parseVersion = (version) => {
    if (!version) {
        return [0];
    }
    return version.split(".").map(Number);
};
if (window.ReactDOM && window.React) {
    var [major] = parseVersion(window.ReactDOM.version);

    if (major >= 18) {
        // 维护容器和root实例的映射
        var rootInstances = window.rootInstances || new Map();

        window.ReactDOM.render = (view, container) => {
            var root = rootInstances.get(container);
            if (!root) {
                root = window.ReactDOM.createRoot(container);
                rootInstances.set(container, root);
            }
            return root.render(view);
        };

        window.ReactDOM.unmountComponentAtNode = (container) => {
            var root = rootInstances.get(container);
            if (root) {
                root.unmount();
                rootInstances.delete(container);
                return true;
            }
            return false;
        };
        // 是否开启并发模式
        window.React18_ConcurrentMode = true;
    } else if (major < 18) {
        // 在react16中兼容 React 18 中的 startTransition
        if (!window.React.startTransition) {
            window.React.startTransition = (callback) => {
                callback();
            };
        }
        // 在react16中模拟 ReactDOM.createRoot
        if (!window.ReactDOM.createRoot) {
            window.ReactDOM.createRoot = (container) => {
                return {
                    render: (element) => {
                        window.ReactDOM.render(element, container);
                    },
                    unmount: () => {
                        window.ReactDOM.unmountComponentAtNode(container);
                    },
                };
            };
        }
    }
}
